import ModalSelectLanguage from "../modals/select-language/modalSelectLanguage";

type callback = ()=>void;

export default class Header{
    private mainHeader:HTMLElement;
    private mainHeaderTranslateOp:HTMLImageElement;
    private closeHomePage:HTMLElement;

    constructor(
        private modalSelectLanguage:ModalSelectLanguage,
        onCloseCallback:callback
    ){
        this.mainHeader = document.querySelector("#main-header") as HTMLElement;
        this.mainHeaderTranslateOp = this.mainHeader.querySelector(".trans-icon") as HTMLImageElement;
        this.closeHomePage = this.mainHeader.querySelector(".btn-close") as HTMLElement;

        this.openTranslateOP();
        this.closeHeader(onCloseCallback);
    }

    showHeader(){
        this.mainHeader.classList.remove("d-none");
    }

    private closeHeader(cb:callback){
        this.closeHomePage.addEventListener("click",()=>{
            this.mainHeader.classList.add("d-none");
            cb();
        });
    }

    private openTranslateOP(){
        this.mainHeaderTranslateOp.addEventListener("click",()=>{
            this.modalSelectLanguage.show();
        });
    }
}